import script from "./validate_products.vue?vue&type=script&setup=true&lang=js"
export * from "./validate_products.vue?vue&type=script&setup=true&lang=js"

import "./validate_products.vue?vue&type=style&index=0&id=311dc0b8&lang=css"

const __exports__ = script;

export default __exports__